export const DOSSIERS_REDUCER_NAME = 'dossiers';
